export default (theme) => ({
	stars: {
		color: "#222",
	},
	bread: {
		fontSize: 15,
		color: "#acacac",
	},
	breadActive: {
		fontSize: 15,
		color: "#222",
	},
	// tabsRoot: {
	// 	position: "relative",
	// },
	tabsScrollButtons: {
		height: 36,
		//border: "1px solid #ddd",
		//borderRadius: 999,
		//margin: "0 10px",
	},
	customDisabledScrollButton: {
		"& .MuiTabScrollButton-root.Mui-disabled": {
			opacity: 1,
			//border: "1px solid #eee",
		},
		"& .Mui-disabled .MuiSvgIcon-root": {
			color: "#ddd",
		},
	},
	tabsIndicator: {
		border: "1px solid #222",
		height: "auto",
		height: 36,
		top: 0,
		backgroundColor: "rgb(14 107 230 / 8%)",
		borderRadius: 999,
	},
	tabRoot: {
		"color": "#222",
		"height": 36,
		"minWidth": "unset",
		"minHeight": 36,
		//"border": "1px solid rgba(0, 0, 0, 0.12)",
		"border": "1px solid #FFF",
		"borderRadius": 999,
		"marginRight": 4,
		"fontSize": 15,
		"fontWeight": 600,
		"padding": "4px 16px",
		"&:hover": {
			border: "1px solid #222",
		},
		"&:last-child": {
			marginRight: 0,
		},
	},
	filterButton: { border: "1px solid rgba(0, 0, 0, 0.12)", padding: 8 },
	TOCList: {
		"width": "100%",
		"position": "relative",
		"overflow": "auto",
		"height": "calc(100vh - 400px)",
		"maxHeight": "calc(100vh - 400px)",
		"padding": "6px 24px 24px",
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar": {
			width: 6,
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#dadada",
			borderRadius: 8,
		},
	},
	SummaryList: {
		"width": "100%",
		"position": "relative",
		"overflow": "auto",

		"maxHeight": "calc(100vh - 400px)",
		"padding": "24px 24px",
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar": {
			width: 6,
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#dadada",
			borderRadius: 8,
		},
	},
	timeLabel: {
		justifyContent: "flex-start",
	},
	filterList: {
		"padding": "16px 24px",
		"width": "100%",
		"position": "relative",
		"overflow": "auto",
		//"height": "calc(100vh - 400px)",
		"maxHeight": 500,
		"padding": "24px 24px 16px",
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar": {
			width: 6,
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#dadada",
			borderRadius: 8,
		},
	},
	buttonBase: {
		"borderRadius": 8,
		"width": "100%",
		"height": "100%",
		"cursor": "pointer",
		"marginBottom": 24,
		//"minHeight": 182,
		//height: 182,
		"-webkit-touch-callout": "none" /* iOS Safari */,
		"-webkit-user-select": "none" /* Safari */,
		"-khtml-user-select": "none" /* Konqueror HTML */,
		"-moz-user-select": "none" /* Old versions of Firefox */,
		"-ms-user-select": "none" /* Internet Explorer/Edge */,
		"userSelect": "none",
		[theme.breakpoints.down("md")]: {
			minHeight: "unset",
		},
	},
	noSelect: {
		"-webkit-touch-callout": "none" /* iOS Safari */,
		"-webkit-user-select": "none" /* Safari */,
		"-khtml-user-select": "none" /* Konqueror HTML */,
		"-moz-user-select": "none" /* Old versions of Firefox */,
		"-ms-user-select": "none" /* Internet Explorer/Edge */,
		"userSelect": "none",
	},
	paper: {
		"width": "100%",
		"height": "100%",
		"&:hover": {
			backgroundColor: "#f7f7f7",
			boxShadow: "inset 0 0 0 var(1px, 1px) var(#bfbfbf, #bfbfbf)",
		},
		[theme.breakpoints.down("xs")]: {
			border: "unset",
			borderBottom: "1px solid #eee",
			paddingBottom: 24,
		},
	},
	selectedPaper: {
		"width": "100%",
		"height": "100%",
		"&:hover": {
			backgroundColor: "#f7f7f7",
			boxShadow: "inset 0 0 0 var(1px, 1px) var(#bfbfbf, #bfbfbf)",
		},
		//"border": "1px solid #0e6be6",
		"border": "1px solid rgba(0, 0, 0, 0.0)",
		"boxShadow": "inset 0 0 0 2px #0e6be6",
		[theme.breakpoints.down("xs")]: {
			border: "unset",
			boxShadow: "unset",
			borderBottom: "1px solid #eee",
			paddingBottom: 24,
		},
	},
	boxWrapper: {
		//padding: "20px 24px",
		display: "flex",
		width: "100%",
		height: "100%",
	},
	boxGap: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 12,
		width: "100%",
	},
	flex: {
		display: "flex",
	},
	categoryBox: {
		margin: "32px 0px",
	},
	category: { fontSize: 24, fontWeight: 600, marginBottom: 24 },
	boxFlex100: {
		display: "flex",
		width: "100%",
		height: "100%",
	},
	itemTitle: { fontSize: 18, fontWeight: 600 },
	itemDetails: {
		color: "#757575",
		fontSize: 15,
		lineHeight: 1.4,
	},
	itemDetailsNoBreak: {
		display: "inline-block",
	},
	chip: { backgroundColor: "#f7f7f7" },
	spotsLeft: {
		fontSize: 14,
		fontWeight: 600,
		color: "#ff5a52",
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	itemTruncate: {
		//whiteSpace: "nowrap",
		"display": "-webkit-box",
		"-webkit-box-orient": "vertical",
		"-webkit-line-clamp": 2,
		"textOverflow": "ellipsis",
		"overflow": "hidden",
		"width": "100%",
		"maxWidth": 450,
		"boxSizing": "border-box",
		[theme.breakpoints.down("md")]: {
			maxWidth: 250,
		},
		[theme.breakpoints.down("sm")]: {
			maxWidth: 280,
		},
		[theme.breakpoints.down("xs")]: {
			maxWidth: 220,
		},
	},
	itemAvatarPadding: {
		padding: "20px 0 20px 20px",
		[theme.breakpoints.down("xs")]: {
			padding: "0 16px 0 0",
		},
	},
	itemAvatar: {
		height: 160,
		width: 160,
		[theme.breakpoints.down("md")]: {
			height: 120,
			width: 120,
		},
		[theme.breakpoints.down("xs")]: {
			height: 80,
			width: 80,
		},
	},
	itemFeatures: {
		display: "flex",
		alignItems: "center",
		gap: 8,
		marginTop: 8,
	},
	itemPrice: {
		fontSize: 15,
		fontWeight: 600,
		marginTop: "auto",
		paddingTop: 8,
		[theme.breakpoints.down("xs")]: {
			paddingTop: 4,
			marginTop: "unset",
		},
	},
	content: {
		flex: "1 1 auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 4,
		width: "calc(100% - 60px)",
		padding: "20px 24px",
		[theme.breakpoints.down("xs")]: {
			padding: "unset",
		},
	},
	rightInfoSpots: {
		flex: "0 0 auto",
		alignItems: "flex-end",
		padding: 20,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		height: "100%",
		[theme.breakpoints.down("xs")]: {
			padding: 10,
		},
	},
	rightInfo: {
		flex: "0 0 auto",
		alignItems: "flex-end",
		padding: 20,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		height: "100%",
		[theme.breakpoints.down("xs")]: {
			padding: 10,
		},
	},
	iconButton: {
		"backgroundColor": "#f2f2f2",
		"color": "#222",
		"borderRadius": 8,
		"&:hover": {
			backgroundColor: "#d0d0d0",
			color: "#222",
		},
	},
	iconButtonSelected: {
		"backgroundColor": "#0e6be6",
		"color": "#FFF",
		"borderRadius": 8,
		"&:hover": {
			backgroundColor: "#094aa1",
			color: "#FFF",
		},
	},
	accordionRoot: {
		"boxShadow": "unset",
		"borderBottom": "1px solid #dddddd",
		"&:before": {
			height: 0,
		},
		"&:last-child": {
			borderBottom: 0,
		},
	},
	accordionSRoot: {
		padding: 0,
	},
	accordionSContent: {
		margin: "24px 0px",
	},
	accordionDetailsRoot: {
		padding: "0px 0px",
	},
	faqQuestion: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: 0,
		marginTop: 0,
		[theme.breakpoints.down("xs")]: {
			fontSize: 16,
		},
	},
	serviceDialogText: {
		fontSize: 16,
		lineHeight: 1.5,
		//color: "#757575"
		color: "#4b4b4b",
	},
	serviceDialogButton: { color: "#0e6be6", display: "block", marginTop: 8 },
	listItemContainer: {
		"borderBottom": "1px solid rgba(0, 0, 0, 0.08)",
		"&:last-child": {
			borderBottom: "unset",
		},
	},
	listButton: {
		borderRadius: 8,
	},
	listMultiline: {
		marginTop: 20,
		marginBottom: 20,
	},
	listPrimary: {
		fontWeight: 600,
		fontSize: 17,
	},
	listPrimaryThin: {
		fontSize: 17,
	},
	listSecondary: {
		fontSize: 16,
	},
	dialogContainer: {
		[theme.breakpoints.down("xs")]: {
			paddingTop: 60,
		},
	},
	dialogContainer2: {
		[theme.breakpoints.down("xs")]: {
			paddingTop: 120,
		},
	},
	dialogContainer3: {
		paddingTop: 60,
		paddingBottom: 60,
		[theme.breakpoints.down("xs")]: {
			paddingTop: 120,
			paddingBottom: 0,
		},
	},
	dialogPaper: {
		borderRadius: 16,
		[theme.breakpoints.down("xs")]: {
			borderRadius: "16px 16px 0px 0px",
		},
	},
	dialogPaper2: {
		borderRadius: 16,
		[theme.breakpoints.down("xs")]: {
			borderRadius: "unset",
		},
	},
	serviceAddTitle: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: "calc(100% - 48px)",
		whiteSpace: "nowrap",
	},

	serviceClassDetail: {
		fontSize: 15,
		lineHeight: 1.5,
		//color: "#757575",
		color: "#4b4b4b",
		display: "flex",
	},
	serviceClassDetailSpan: {
		minWidth: 90,
		display: "inline-block",
		fontWeight: 600,
		color: "#222",
	},
	showMoreText: {
		"lineHeight": "23px",
		"maxHeight": 69,
		"textOverflow": "ellipsis",
		"display": "-webkit-box",
		"-webkit-line-clamp": 3,
		"-webkit-box-orient": "vertical",
		"overflow": "hidden",
		"marginBottom": 8,
		"color": "#757575",
	},
	imageList: {
		borderRadius: 4,
		cursor: "pointer",
	},
	hoursDialogDay: {
		padding: "6px 0 6px 0",
		fontWeight: 600,
	},
	hoursDialogTime: {
		padding: "6px 0 6px 0",
	},
	staffListItem: {
		paddingTop: 16,
		paddingBottom: 16,
	},
	staffListItemAvatarRoot: {
		minWidth: 84,
	},
	staffListAvatarRoot: {
		width: 64,
		height: 64,
	},
	staffSelect: {
		padding: "8px 10px",
	},
	buttonFunnelDayBox: {
		gap: 30,
		[theme.breakpoints.down("md")]: {
			gap: 20,
		},
		[theme.breakpoints.down("xs")]: {
			gap: 6,
		},
	},
	buttonFunnelDayBoxDialog: {
		gap: 20,
		[theme.breakpoints.down("md")]: {
			gap: 20,
		},
		[theme.breakpoints.down("xs")]: {
			gap: 6,
		},
	},
	buttonFunnelDay: {
		//border: "1px solid #d3d3d3",
		minWidth: "auto",
		padding: "6px 8px",
		[theme.breakpoints.down("xs")]: {
			padding: "4px 6px",
			minWidth: "auto",
		},
	},
	bookingFunnelTimeButton: {
		"backgroundColor": "#f6faff",
		//"color": "#222",
		"&:hover": {
			//backgroundColor: "#E6F0FF",
		},
	},
	loginSeparator: {
		"fontSize": 13,
		"color": "#bfbfbf",
		"textAlign": "center",
		"position": "relative",
		"marginBottom": 24,
		"marginTop": 24,
		"&:before": {
			left: 0,
			width: "45%",
			background: "rgb(221, 221, 221) !important",
			content: `""`,
			display: "block",
			height: 1,
			position: "absolute",
			top: "50%",
		},
		"&:after": {
			right: 0,
			width: "45%",
			background: "rgb(221, 221, 221) !important",
			content: `""`,
			display: "block",
			height: 1,
			position: "absolute",
			top: "50%",
		},
	},
	or: {
		color: theme.palette.text.secondary,
		fontSize: 11,
		textTransform: "uppercase",
	},
	buttonSocial: {
		"backgroundColor": "#ffffff",
		"border": "1px solid #babfc3",
		"&:hover": { backgroundColor: "rgba(9, 30, 66, 0.05)" },
		"height": 52,
	},
	buttonCTA: {
		height: 52,
	},
	boxCartWrapper: {
		borderBottom: "1px solid #dddddd",
		padding: "24px 0px",
	},
	boxCart: {
		display: "flex",
		width: "100%",
	},
	contentCart: {
		flex: "1 1 auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 4,
		paddingLeft: 24,
	},
	accordionRoot: {
		"boxShadow": "unset",
		"borderBottom": "1px solid #dddddd",
		"&:before": {
			height: 0,
		},
		"&:last-child": {
			borderBottom: 0,
		},
	},
	accordionSRoot: {
		padding: 0,
	},
	accordionSContent: {
		margin: "24px 0px",
	},
	accordionDetailsRoot: {
		padding: "0px 0px 36px",
	},
	checkoutQuestion: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 0,
		marginTop: 0,
	},
	checkoutAnswer: {
		color: "#424242",
		lineHeight: 1.5,
	},
	tabsIndicatorCheckout: {
		border: "2px solid #0e6be6",
		height: "auto",
		top: 0,
		backgroundColor: "rgb(14 107 230 / 8%)",
		borderRadius: 8,
	},
	tabRootCheckout: {
		"color": "#222",
		//"height": 58,
		//"minHeight": 58,
		"border": "1px solid rgba(0, 0, 0, 0.12)",
		"borderRadius": 8,
		"marginRight": 16,
		"fontSize": 16,
		"fontWeight": 600,
		"padding": 12,
		"&:hover": {
			border: "1px solid #222",
		},
		"&:last-child": {
			marginRight: 0,
		},
	},
});
